import { Typography, useTheme } from '@mui/material';
import { styled } from '@mui/system';

export const ShopNotFoundTypography = styled(Typography)(() => ({
  color: '#393939',
  fontWeight: 700,
  fontFamily: `${useTheme().custom.styles.primaryDescription}`,
  fontSize: '16px',
}));
